import { createContext } from 'react'
import type { RefObject } from 'react'
import type { Path } from '../types'
import type { ContainerMode } from './Array/types'

export type ModeOptions = {
  omitFocusManagement?: boolean
  preventUpdate?: boolean
}

export type IterateItemContextState = {
  id?: string
  index?: number
  value?: unknown
  isNew?: boolean
  path?: Path
  itemPath?: Path
  nestedIteratePath?: Path
  arrayValue?: Array<unknown>
  containerMode?: ContainerMode
  previousContainerMode?: ContainerMode
  initialContainerMode?: ContainerMode
  containerRef?: RefObject<HTMLDivElement>
  elementRef?: RefObject<HTMLDivElement>
  modeOptions?: ModeOptions
  switchContainerMode?: (
    mode: ContainerMode,
    options?: ModeOptions
  ) => void
  handleChange?: (path: Path, value: unknown) => void
  handleRemove?: ({ keepItems }?: { keepItems?: boolean }) => void
  handlePush?: (value: unknown) => void
  restoreOriginalValue?: (value?: unknown) => void
  fulfillRemove?: () => void
}

const IterateItemContext = createContext<
  IterateItemContextState | undefined
>(undefined)

export default IterateItemContext
